import { maptiler } from "pigeon-maps/providers";

const maptilerProvider = maptiler(
  process.env.REACT_APP_MAP_TILER_API_TOKEN,
  "streets"
);

export default maptilerProvider;
